import * as Yup from 'yup';

import { FORM_VALIDATION_ERRORS } from 'src/consts';

const initialValues = {
  pharmacyName: '',
  pharmacyStreets: '',
  pharmacyPhone: '',
  pharmacyZipCode: '',
  isNewEntry: false,
};

const validation = {
  initialValues,
  schema: Yup.object().shape({
    pharmacyName: Yup.string().required(FORM_VALIDATION_ERRORS.pharmacyName),
    pharmacyStreets: Yup.string().test('pharmacy-streets', FORM_VALIDATION_ERRORS.pharmacyDetails, function () {
      const { pharmacyStreets, isNewEntry } = this.parent;
      return isNewEntry || pharmacyStreets;
    }),
  }),
};

export { validation };
